var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"header-button",class:{ active: _vm.isActive }},[_c('span',{staticClass:"icon-wrapper"},[_c('i',{class:'icon fa fa-' + _vm.iconName})]),_c('span',{staticClass:"btn-text mobile-only"},[_vm._v(" "+_vm._s(_vm.btnText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }